import type { LocationEntity } from "./location.type";
import type { Int } from "@/types";

export const isSector = (location?: LocationEntity) => {
  return location?.location_id ? true : false;
};

export const canBeParentLocation = (
  location: LocationEntity,
  currentLocationId: Int
): boolean => {
  // Cannot be parent if it's the same location
  if (location.id === currentLocationId) return false;

  // Cannot be parent if current location is its ancestor (would create cycle)
  return !(location.ancestors ?? []).some(({ id }) => id === currentLocationId);
};
